import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

interface HeroAnimationProps {
  imagePath: string;
}

const HeroAnimation: React.FC<HeroAnimationProps> = ({ imagePath }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  // Varianti per le animazioni
  const imageVariants = {
    hidden: { scale: 1.1, opacity: 0 },
    visible: { 
      scale: 1, 
      opacity: 1,
      transition: { 
        duration: 1.5, 
        //ease: [0.6, 0.01, -0.05, 0.95]
        ease: "easeOut"  // Opzione 1
      }
    }
  };

  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        duration: 1.2,
        delay: 0.3
      }
    }
  };

  const textContainerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        delayChildren: 0.8,
        staggerChildren: 0.3
      }
    }
  };

  const textItemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { 
      y: 0, 
      opacity: 1,
      transition: { 
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Immagine di sfondo con animazione */}
      <motion.div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${imagePath})` }}
        initial="hidden"
        animate={isLoaded ? "visible" : "hidden"}
        variants={imageVariants}
      />
      
      {/* Overlay sfumato */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"
        initial="hidden"
        animate={isLoaded ? "visible" : "hidden"}
        variants={overlayVariants}
      />
      
      {/* Contenuto testuale */}
      <div className="relative z-10 h-full flex items-center">
        <div className="container mx-auto px-4">
          <motion.div
            className="max-w-3xl"
            initial="hidden"
            animate={isLoaded ? "visible" : "hidden"}
            variants={textContainerVariants}
          >
            <motion.h1 
              className="font-playfair text-5xl md:text-7xl text-white mb-6"
              variants={textItemVariants}
            >
              Villa d'Arco
            </motion.h1>
            <motion.p 
              className="font-montserrat text-xl md:text-2xl text-white mb-8"
              variants={textItemVariants}
            >
              La natura che regala emozioni
            </motion.p>
            <motion.div 
              className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
              variants={textItemVariants}
            >
              <a 
                href="/azienda-agricola" 
                className="btn-primary"
              >
                La Nostra Azienda Agricola
              </a>
              <a 
                href="/ristorante" 
                className="btn-secondary "
              >
                Scopri il Ristorante
              </a>
              
            </motion.div>
          </motion.div>
        </div>
      </div>
      
      {/* Elemento decorativo animato */}
      <motion.div
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2"
        initial={{ opacity: 0, y: 20 }}
        animate={{ 
          opacity: isLoaded ? 1 : 0, 
          y: isLoaded ? 0 : 20 
        }}
        transition={{ 
          duration: 0.8,
          delay: 2
        }}
      >
        <div className="flex flex-col items-center">
          <span className="text-white font-montserrat text-sm mb-2">Scopri di più</span>
          <svg 
            className="w-6 h-6 text-white animate-bounce" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M19 14l-7 7m0 0l-7-7m7 7V3" 
            />
          </svg>
        </div>
      </motion.div>
    </div>
  );
};

export default HeroAnimation;
